import {
  Grid,
  Typography,
  Box,
  FormControl,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Select,
  MenuItem,
  OutlinedInput,
  DialogTitle,
  Paper,
  Divider,
  InputAdornment,
  Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import BackspaceIcon from "@mui/icons-material/Backspace";
import Keypad from "./Keypad";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import LockIcon from "@mui/icons-material/Lock";
import ScaleIcon from "@mui/icons-material/Scale";
import CheckIcon from "@mui/icons-material/Check";
import Webcam from "react-webcam";
import { SALENG_SHOP_API_PROD } from "../config";
import { getAuthorizationHeaders } from "../services/apiClient";
import { formatNumber } from "../utils/formatNumber";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import PriceSelectionDialog from "./PriceSelectionDialog";
import { useProductsBranch } from "../hooks/useProductsBranch";
import ProductSelectDialog from "./ProductSelectDialog";
import { hasPermission } from "../auth/RequirePermission3";
import * as services from "../services/saleng";

const SALENG_SHOP_API = SALENG_SHOP_API_PROD;
const beep = new Audio("/sounds/beep.mp3");

const SimpleDialog = (props) => {
  const theme = useTheme();
  const { open, onClose, onSubmit, selectedValue, transaction, isWeighed } = props;

  const [weight, setWeight] = useState(0);
  const [deduct, setDeduct] = useState(0);
  const [focusedImpurityIndex, setFocusedImpurityIndex] = useState(null);
  const [focusedImpurityField, setFocusedImpurityField] = useState(null);
  const [focusedImpuritySource, setFocusedImpuritySource] = useState(null);
  const [productPrice, setProductPrice] = useState();
  const [priceInput, setPriceInput] = useState("");
  const [isEditingPrice, setIsEditingPrice] = useState(false);
  const [mute, setMute] = useState(true);
  const [focused, setFocused] = useState("weight");
  const [isDisabled, setIsDisabled] = useState(true);
  const [openPriceDialog, setOpenPriceDialog] = useState(false);
  const [snapshots, setSnapshots] = useState([]);
  const lastWeightRef = useRef(null);
  const stableStartTimeRef = useRef(null);
  const beepPlayedRef = useRef(false);
  const prevOpenRef = useRef(false);
  const prevSelectedIdRef = useRef(null);
  const latestFinalPriceRef = useRef(
    Number(
      selectedValue?.finalPrice ??
        selectedValue?.pricePerUnit ??
        selectedValue?.value?.finalPrice ??
        selectedValue?.value?.pricePerUnit ??
        0
    ) || 0
  );

  const syncFinalPrice = (nextPrice) => {
    const normalized = Number(nextPrice ?? 0) || 0;
    latestFinalPriceRef.current = normalized;
    setProductPrice((prev) => ({ ...(prev || {}), finalPrice: normalized }));
  };

  const [openProdDialog, setOpenProdDialog] = useState(false);
  const [isFirstKeypress, setIsFirstKeypress] = useState(true);
  const [catFilter, setCatFilter] = useState(null);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [devices, setDevices] = useState([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState("");

  const [impurities, setImpurities] = useState([
    { kind: "", type: "", weight: 0 },
  ]);
  const [deductedItems, setDeductedItems] = useState([{ type: "", weight: 0 }]);

  const [isLockedPriceState, setIsLockedPriceState] = useState(
    selectedValue?.value?.isLockedPrice ?? false
  );

  const deductKindOptions = [
    { value: "convert", label: "หักเป็นสินค้าอื่น" },
    { value: "discard", label: "หักทิ้ง" },
    { value: "return", label: "หักคืน" },
  ];

  const impurityOptions = [
    "ปุ๋ย",
    "เต๋า",
    "ลัง",
    "ขยะฝุ่นดิน",
    "ลวดรัด",
    "ถุงพลาสติก",
    "สินค้าไม่รับซื้อ",
    "กระบะ",
    "เหล็กทิ้ง",
    "น้ำ",
    "พลาสติก",
    "สติ๊กเกอร์",
    "พาเลท",
    "ความชื้น",
    "เชือก",
    "น้ำมัน",
    "เปอร์เซ็นต์",
    "สี",
    "ปูน",
    "ไม้",
    "ตระกร้า",
  ];

  const TYPE_WHITELIST = {
    discard: [
      "ปุ๋ย",
      "เต๋า",
      "ลัง",
      "ขยะฝุ่นดิน",
      "ลวดรัด",
      "ถุงพลาสติก",
      "สินค้าไม่รับซื้อ",
      "กระบะ",
      "เหล็กทิ้ง",
      "น้ำ",
      "พลาสติก",
      "สติ๊กเกอร์",
      "พาเลท",
      "ความชื้น",
      "เชือก",
      "น้ำมัน",
      "เปอร์เซ็นต์",
      "สี",
      "ปูน",
      "ไม้",
      "ตระกร้า",
    ],
    return: [
      "ปุ๋ย",
      "เต๋า",
      "ลัง",
      "ขยะฝุ่นดิน",
      "ลวดรัด",
      "ถุงพลาสติก",
      "สินค้าไม่รับซื้อ",
      "กระบะ",
      "เหล็กทิ้ง",
      "น้ำ",
      "พลาสติก",
      "สติ๊กเกอร์",
      "พาเลท",
      "ความชื้น",
      "เชือก",
      "น้ำมัน",
      "เปอร์เซ็นต์",
      "สี",
      "ปูน",
      "ไม้",
      "ตระกร้า",
    ],
    convert: ["__deduct_product__"],
  };

  const normalize = (s = "") => s.replace(/\s|\+/g, "");

  const getTypeOptionsByKind = (kind) => {
    if (!kind) return [];
    if (kind === "convert") return ["__deduct_product__"];
    const allow = TYPE_WHITELIST[kind] || [];
    const allowNorm = allow.map(normalize);
    return impurityOptions.filter((opt) =>
      allowNorm.some((a) => normalize(opt).includes(a))
    );
  };

  const inferKindFromType = (type) => {
    if (!type) return "";
    // กรณีพิเศษ: หักเป็นสินค้าอื่น
    if (type === "__deduct_product__") return "convert";

    const t = normalize(type);
    for (const [kind, arr] of Object.entries(TYPE_WHITELIST)) {
      const allowNorm = arr.map(normalize);
      // ใช้ทั้ง equal และ includes เผื่อชื่อ type มีคำขยาย
      if (allowNorm.some((a) => a === t || t.includes(a))) {
        return kind;
      }
    }
    return "";
  };

  const webcamRef = useRef(null);
  const weightInputRef = useRef(null);
  const impurityWeightRefs = useRef({});
  const impurityTypeRefs = useRef({});
  const priceInputRef = useRef(null);

  const focusImpurityTypeAt = (source, index) => {
    const key = `${source}-${index}`;
    const el = impurityTypeRefs.current[key];
    el?.focus?.();
  };

  const [inputValue, setInputValue] = useState(0);
  const { products } = useProductsBranch(transaction?.id);
  const [categoryPricing, setCategoryPricing] = useState([]);
  const [openMainProdDialog, setOpenMainProdDialog] = useState(false);
  const [mainProduct, setMainProduct] = useState(null);
  const [prodPickerIndex, setProdPickerIndex] = useState(null);
  const [prodPickerSource, setProdPickerSource] = useState(null);
  const [note, setNote] = useState("");

  const [isEditingNote, setIsEditingNote] = useState(false);
  const [cursorPos, setCursorPos] = useState(0);

  const categories = useMemo(() => {
    const seen = new Set();
    return (products || [])
      .map((p) => p.category)
      .filter((cat) => {
        if (!cat) return false;
        if (seen.has(cat.name)) return false;
        seen.add(cat.name);
        return true;
      })
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }, [products]);

  const hasCustomerGroup = useMemo(
    () =>
      Boolean(transaction?.customerGroupId) ||
      Boolean(transaction?.customer?.customerGroupId),
    [transaction]
  );

  const pickTierByWeight = useCallback((prices = [], weight = 0) => {
    if (!Array.isArray(prices) || prices.length === 0) {
      return { adjPrice: 0, minWeight: 0 };
    }

    const sorted = [...prices].sort(
      (a, b) => Number(a?.minWeight ?? 0) - Number(b?.minWeight ?? 0)
    );

    let chosen = { adjPrice: 0, minWeight: 0 };
    for (const tier of sorted) {
      if (Number(tier?.minWeight ?? 0) <= Number(weight ?? 0)) {
        chosen = tier;
      } else {
        break;
      }
    }

    return {
      adjPrice: Number(chosen?.adjPrice ?? 0) || 0,
      minWeight: Number(chosen?.minWeight ?? 0) || 0,
    };
  }, []);

  const resolveBasePriceFromProduct = useCallback((prod) => {
    if (!prod) return 0;
    const num = (v) => Number(v ?? 0) || 0;
    if (prod.basePrice != null) {
      return num(prod.basePrice) + num(prod.branchAdjustment);
    }
    return (
      num(prod.finalPriceWithGroup) ||
      num(prod.finalPrice) ||
      num(prod.price) ||
      0
    );
  }, []);

  const focusMainWeight = useCallback(() => {
    const el = weightInputRef.current;
    if (el) {
      el.focus();
      if (typeof el.select === "function") el.select();
    }
    setIsEditingNote(false);
    setFocusedImpurityIndex(null);
    setFocusedImpurityField(null);
    setFocusedImpuritySource(null);
    setInputValue(weight || 0);
    setCursorPos(String(weight || 0).length);
    setIsFirstKeypress(true);
  }, [weight]);

  const focusImpurityWeightAt = useCallback(
    (source, index) => {
      const key = `${source}-${index}`;
      const el = impurityWeightRefs.current[key];

      if (el) {
        el.focus({ preventScroll: true });
        queueMicrotask(() => {
          try {
            const len = String(el.value ?? "").length;
            el.setSelectionRange?.(len, len);
          } catch { }
        });
        // Use the value from the element itself to ensure we get what's rendered
        const weightVal = sanitizeNumber(el.value);
        setInputValue(weightVal || 0);
        setCursorPos(String(weightVal || 0).length);
      }
      setIsEditingNote(false);
      setFocusedImpurityIndex(index);
      setFocusedImpurityField("weight");
      setFocusedImpuritySource(source);
      setIsFirstKeypress(true);
    },
    []
  );

  useEffect(() => {
    // Only reset product price if it's not currently being edited or if it's a different product
    const isNewOpen = open && !prevOpenRef.current;
    const isDifferentId = selectedValue?.id !== prevSelectedIdRef.current;

    if (selectedValue && (isNewOpen || isDifferentId)) {
      const initialPrice =
        Number(
          selectedValue?.finalPrice ??
            selectedValue?.pricePerUnit ??
            selectedValue?.value?.finalPrice ??
            selectedValue?.value?.pricePerUnit ??
            0
        ) || 0;
      const initialBasePrice = resolveBasePriceFromProduct(
        selectedValue?.value?.product ??
          selectedValue?.value ??
          selectedValue
      );
      latestFinalPriceRef.current = initialPrice;
      setProductPrice({
        ...(selectedValue || {}),
        basePrice: initialBasePrice,
        finalPrice: initialPrice,
      });
    }
  }, [selectedValue, open, resolveBasePriceFromProduct]);

  useEffect(() => {
    let isMounted = true;

    const fetchCategoryPricing = async () => {
      if (!open) return;
      try {
        const res = await services.getCategories();
        const cats = res?.data?.data || res?.data || [];
        if (isMounted) {
          setCategoryPricing(Array.isArray(cats) ? cats : []);
        }
      } catch (error) {
        console.error("Failed to fetch categories for auto pricing:", error);
        if (isMounted) {
          setCategoryPricing([]);
        }
      }
    };

    fetchCategoryPricing();

    return () => {
      isMounted = false;
    };
  }, [open]);

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then((devs) => {
      const videoInputs = devs.filter((d) => d.kind === "videoinput");
      setDevices(videoInputs);

      const savedId = localStorage.getItem("preferred_camera_product_form");
      if (savedId && videoInputs.some((d) => d.deviceId === savedId)) {
        setSelectedDeviceId(savedId);
      } else if (videoInputs.length > 0) {
        setSelectedDeviceId(videoInputs[0].deviceId);
      }
    });
    if (selectedValue?.id && selectedValue?.title) {
      setMainProduct({
        id: selectedValue.id,
        title: selectedValue.title,
        categoryId: selectedValue.categoryId,
      });
    } else {
      setMainProduct(null);
    }
    setNote(selectedValue?.note ?? "");
    setIsLockedPriceState(selectedValue?.value?.isLockedPrice ?? false);
  }, [selectedValue]);

  useEffect(() => {
    const isNewOpen = open && !prevOpenRef.current;
    const isDifferentId = selectedValue?.id !== prevSelectedIdRef.current;

    if (selectedValue && (isNewOpen || isDifferentId)) {
      const {
        weight: w = 0,
        deduct: d = 0,
        impurities: imps = [],
        deductedItems: deds = [],
      } = selectedValue;
      setWeight(w);
      setDeduct(d);
      setImpurities(
        (imps || []).map((it) => {
          const type = it.type ?? "";
          const kind = (it.kind ?? "").trim() || inferKindFromType(type);
          return {
            kind,
            type,
            ...it,
          };
        })
      );
      setDeductedItems(deds);
      prevSelectedIdRef.current = selectedValue?.id;
    }

    const socket = new WebSocket("ws://localhost:3001/ws");
    socket.onmessage = handleData;

    const interval = setInterval(() => {
      if (
        lastWeightRef.current !== null &&
        stableStartTimeRef.current !== null
      ) {
        const elapsed = Date.now() - stableStartTimeRef.current;
        if (
          elapsed >= 2500 &&
          !beepPlayedRef.current &&
          lastWeightRef.current !== 0 &&
          !mute
        ) {
          beepPlayedRef.current = true;
        }
      }
    }, 200);

    if (!open) {
      setWeight(0);
      setDeduct(0);
      setImpurities([{ kind: "", type: "", weight: 0 }]);
      setFocusedImpurityIndex(null);
      setFocusedImpurityField(null);
      setFocusedImpuritySource(null);
      setInputValue(0);
      setCursorPos(1);
      setNote("");
      setIsEditingNote(false);
      setProdPickerIndex(null);
      setProdPickerSource(null);
      impurityWeightRefs.current = {};
      impurityTypeRefs.current = {};
      prevSelectedIdRef.current = null;
    }

    prevOpenRef.current = open;

    return () => {
      socket.close();
      clearInterval(interval);
    };
  }, [selectedValue, open, mute]);

  useEffect(() => {
    if (!isEditingPrice) {
      const val = productPrice?.finalPrice;
      setPriceInput(val === undefined || val === null ? "" : String(val));
    }
  }, [productPrice?.finalPrice, isEditingPrice]);

  const calculateNetWeight = (w, d, i) => {
    const weightNum = parseFloat(w || 0);
    const deductNum = parseFloat(d || 0);
    const impuritiesNum = parseFloat(i || 0);
    return weightNum - deductNum - impuritiesNum;
  };

  const totalImpurityWeight = useMemo(() => {
    const normalImpuritiesWeight = impurities.reduce(
      (sum, item) => sum + parseFloat(item.weight || 0),
      0
    );
    const deductedItemsWeight = deductedItems.reduce(
      (sum, item) => sum + parseFloat(item.weight2 || 0),
      0
    );
    return normalImpuritiesWeight + deductedItemsWeight;
  }, [impurities, deductedItems]);

  const netWeight = useMemo(() => {
    return calculateNetWeight(weight, deduct, totalImpurityWeight);
  }, [weight, deduct, totalImpurityWeight]);

  const currentCategoryId = useMemo(
    () =>
      mainProduct?.categoryId ??
      selectedValue?.categoryId ??
      selectedValue?.value?.categoryId ??
      selectedValue?.value?.product?.categoryId ??
      selectedValue?.value?.product?.category?.id ??
      null,
    [mainProduct, selectedValue]
  );

  const editingItemId = useMemo(
    () =>
      selectedValue?.itemId ?? selectedValue?.value?.id ?? selectedValue?.id ?? null,
    [selectedValue]
  );

  const autoCategoryAdjustment = useMemo(() => {
    if (hasCustomerGroup || !currentCategoryId) return 0;

    const matchedCategory = categoryPricing.find(
      (cat) => Number(cat?.id) === Number(currentCategoryId)
    );
    if (!matchedCategory) return 0;

    const totalsByCat = new Map();
    for (const item of transaction?.items || []) {
      const itemId = item?.id ?? null;
      if (editingItemId != null && String(itemId) === String(editingItemId)) {
        continue;
      }

      const catId =
        item?.product?.categoryId ??
        item?.product?.category?.id ??
        item?.categoryId ??
        null;
      if (!catId) continue;

      const key = Number(catId);
      totalsByCat.set(key, (totalsByCat.get(key) || 0) + Number(item?.netWeight ?? 0));
    }

    totalsByCat.set(
      Number(currentCategoryId),
      (totalsByCat.get(Number(currentCategoryId)) || 0) + Number(netWeight || 0)
    );

    const totalWeight = Number(totalsByCat.get(Number(currentCategoryId)) || 0);
    const tier = pickTierByWeight(matchedCategory?.prices, totalWeight);
    return Number(tier?.adjPrice ?? 0) || 0;
  }, [
    hasCustomerGroup,
    currentCategoryId,
    categoryPricing,
    transaction?.items,
    editingItemId,
    netWeight,
    pickTierByWeight,
  ]);

  const autoFinalPrice = useMemo(() => {
    if (hasCustomerGroup) return null;
    const base = Number(productPrice?.basePrice ?? 0) || 0;
    return base + Number(autoCategoryAdjustment ?? 0);
  }, [hasCustomerGroup, productPrice?.basePrice, autoCategoryAdjustment]);

  useEffect(() => {
    if (!open || hasCustomerGroup || isLockedPriceState) return;
    if (autoFinalPrice == null || Number.isNaN(Number(autoFinalPrice))) return;

    const normalized = Number(autoFinalPrice) || 0;
    latestFinalPriceRef.current = normalized;
    setProductPrice((prev) => ({
      ...(prev || {}),
      basePrice: Number(prev?.basePrice ?? 0) || 0,
      finalPrice: normalized,
    }));
    setIsLockedPriceState(false);
  }, [open, hasCustomerGroup, isLockedPriceState, autoFinalPrice]);

  const isNetNegative = netWeight < 0;
  const canSubmit = true;

  const sanitizeNumber = (s) => {
    if (s == null) return "";
    let x = String(s).replace(/[^\d.]/g, "");
    const parts = x.split(".");
    if (parts.length > 2) x = parts[0] + "." + parts.slice(1).join("");
    if (/^0+\d/.test(x)) x = x.replace(/^0+/, "");
    return x;
  };

  const sanitizeDraftInput = (raw) => {
    if (raw == null) return "0";
    let next = String(raw).replace(/[^\d.]/g, "");
    if (next === "") return "0";
    if (/^0+$/.test(next)) return "0";
    const parts = next.split(".");
    if (parts.length > 2) {
      next = parts[0] + "." + parts.slice(1).join("");
    }
    const [intPart, decPart] = next.split(".");
    if (decPart !== undefined && decPart.length > 2) {
      next = `${intPart}.${decPart.slice(0, 2)}`;
    }
    if (/^0+\d/.test(next)) {
      next = next.replace(/^0+/, "");
    }
    if (next === "") return "0";
    if (next.startsWith(".")) return `0${next}`;
    return next;
  };

  const commitDraft = (nextValue, nextCursor = null) => {
    const safeValue = sanitizeDraftInput(nextValue);
    const normalized = safeValue === "" ? "0" : safeValue;
    setInputValue(normalized);
    setCursorPos(
      Math.max(
        0,
        Math.min(
          nextCursor == null ? normalized.length : nextCursor,
          normalized.length
        )
      )
    );
  };

  useEffect(() => {
    const isWeight = transaction?.isWeighed || false;
    setIsDisabled(isWeight);

    // Only set default focus when the dialog is FIRST opened
    // or if the transaction ID changes (which means a new context)
    if (open && !prevOpenRef.current) {
      setFocused("weight");
    }
  }, [transaction, open]);

  useEffect(() => {
    if (focused === null) return;
    if (focused === "weight") {
      const next = weight || 0;
      setInputValue(next);
      setCursorPos(String(next).length);
    } else if (focused === "deduct") {
      const next = deduct || 0;
      setInputValue(next);
      setCursorPos(String(next).length);
    } else if (focused === "price") {
      const next = productPrice?.finalPrice ?? 0;
      setInputValue(next);
      setCursorPos(String(next).length);
    }
  }, [focused, weight, deduct, productPrice?.finalPrice]);

  useEffect(() => {
    if (!open) return;
    const isTypingInTextInput = () => {
      const el = document.activeElement;
      if (!el) return false;
      const tag = el.tagName?.toLowerCase();
      const isInputLike =
        (tag === "input" ||
          tag === "textarea" ||
          el.getAttribute?.("contenteditable") === "true") &&
        !el.readOnly;
      return isInputLike;
    };

    const commitDraftFromText = (nextStr, nextCursor = null) => {
      const v = sanitizeDraftInput(nextStr);
      setInputValue(v === "" ? 0 : v);
      setCursorPos(
        Math.max(
          0,
          Math.min(
            nextCursor == null ? String(v || 0).length : nextCursor,
            String(v || 0).length
          )
        )
      );
    };

    const onKeyDown = (e) => {
      if (isEditingNote) return;
      if (openProdDialog || openMainProdDialog || openPriceDialog) return;
      if (isTypingInTextInput()) return;

      const editing =
        focused === "weight" ||
        focused === "deduct" ||
        focused === "price" ||
        focusedImpurityIndex !== null;
      if (!editing) return;

      if (isWeighed && focused !== "price") return;

      const key = e.key;
      const cur = String(inputValue ?? 0);
      const currentCursor = Math.max(
        0,
        Math.min(cursorPos, cur.length)
      );

      if (/^[0-9]$/.test(key) || key === ".") {
        e.preventDefault();
        const base =
          cur === "0" && currentCursor === cur.length && key !== "."
            ? ""
            : cur;
        const next = sanitizeDraftInput(
          base.slice(0, currentCursor) +
            (key === "." && cur.includes(".") ? "" : key) +
            base.slice(currentCursor)
        );
        if (next === cur && key === ".") return;
        const nextCursor = Math.min(
          currentCursor + 1,
          String(next || 0).length
        );
        commitDraftFromText(next, nextCursor);
        return;
      }

      if (key === "Backspace") {
        e.preventDefault();
        const nextCursor = Math.max(0, currentCursor - 1);
        if (currentCursor === 0) {
          commitDraftFromText("0", 0);
          return;
        }
        const next = cur.slice(0, nextCursor) + cur.slice(currentCursor);
        commitDraftFromText(next, nextCursor);
        return;
      }

      if (key === "Escape") {
        e.preventDefault();
        commitDraftFromText("0", 1);
        return;
      }

      if (key === "Enter") {
        e.preventDefault();
        handleKeypadSubmit(inputValue);
        return;
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [
    open,
    inputValue,
    focused,
    focusedImpurityField,
    focusedImpurityIndex,
    openProdDialog,
    openMainProdDialog,
    openPriceDialog,
    isEditingNote,
    impurities.length,
    focusedImpuritySource,
    isWeighed,
    cursorPos,
  ]);

  const handleData = (event) => {
    const data = JSON.parse(event.data);
    if (data.weight != null) {
      const rawWeight = Number(data.weight);
      const roundedWeight = parseFloat(rawWeight.toFixed(3));
      if (
        lastWeightRef.current === null ||
        Math.abs(roundedWeight - lastWeightRef.current) > 0.05
      ) {
        lastWeightRef.current = roundedWeight;
        stableStartTimeRef.current = Date.now();
        beepPlayedRef.current = false;
      }
    }
  };

  const captureImage = useCallback(async () => {
    if (!webcamRef.current) return null;
    const video = webcamRef.current.video;
    if (!video || video.readyState < 2) {
      console.warn("No webcam video available");
      return null;
    }
    const canvas = document.createElement("canvas");
    canvas.width = 1920;
    canvas.height = 1080;
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageSrc = canvas.toDataURL("image/jpeg", 1);
    if (!imageSrc) return null;
    const blob = await (await fetch(imageSrc)).blob();
    const file = new File([blob], "webcam_photo.jpg", { type: "image/jpeg" });
    return file;
  }, []);

  async function uploadFile(file) {
    if (!file) throw new Error("No file to upload");
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetch(SALENG_SHOP_API + "/files", {
      method: "POST",
      headers: getAuthorizationHeaders(),
      body: formData,
    });
    if (!response.ok) throw new Error("Upload failed: " + response.statusText);
    const result = await response.json();
    return result;
  }

  const handleClose = () => {
    setSnapshots([]);
    setWeight("");
    setDeduct("");
    setNote("");
    setImpurities([{ kind: "", type: "", weight: 0 }]);
    onClose();
  };

  const handleSubmit = async () => {
    console.log("snapshots", snapshots);

    try {
      const normalImpurities = impurities.filter(
        (imp) => imp.type !== "__deduct_product__"
      );
      const deductedItemImpurities = impurities.filter(
        (imp) => imp.type === "__deduct_product__"
      );

      // helper: ดึงรูปที่ match กับ item ตาม source + createdAt
      const pickSnapshotsFor = (source, createdAt) => {
        if (!createdAt) return [];
        return (snapshots || [])
          .filter(
            (s) =>
              s?.context?.type === "impurity" &&
              s?.context?.source === source &&
              s?.context?.createdAt === createdAt
          )
          .map((s) => ({
            url: s.url,
            at: s.at,
            label: s.context?.label,
            productId: s.context?.productId,
            productName: s.context?.productName,
            isDeductProduct: !!s.context?.isDeductProduct,
          }));
      };

      // รูปทั่วไปที่ไม่ใช่ของแถวสิ่งเจือปน (พวก weight/deduct/price)
      const generalSnapshots = (snapshots || [])
        .filter(
          (s) =>
            s?.context?.type === "weight" ||
            s?.context?.type === "deduct" ||
            s?.context?.type === "price" ||
            s?.context?.type === "unknown"
        )
        .map((s) => ({ url: s.url, at: s.at, label: s.context?.type }));

      // ====== แปลง “หักเป็นสินค้าอื่น” ที่มาจาก impurities ======
      const dedFromImpurities = deductedItemImpurities
        .map((imp) => {
          const prod = (products || []).find((p) => p.id === imp.productId);
          console.log("prod", prod);
          const w = parseFloat(imp.weight || 0);
          return {
            title: imp.productName,
            productId: imp.productId,
            productName: imp.productName,
            price: prod?.finalPrice,
            weight: w,
            createdAt: imp.createdAt, // เก็บไว้ผูกกับรูป
            source: "impurities", // บอก source ให้ชัด
            attachedImages: pickSnapshotsFor("impurities", imp.createdAt),
            ...imp,
          };
        })
        .filter(Boolean);

      // ====== แปลง “deductedItems” ที่อยู่ใน state อยู่แล้ว ======
      const dedFromState = (deductedItems || []).map((it) => {
        const w = parseFloat(it.weight2 || 0);
        return {
          id: it.id,
          title: it.productName,
          productId: it.productId,
          productName: it.productName,
          price: it.pricePerUnit,
          weight: w,
          createdAt: it.createdAt, // เก็บไว้ผูกกับรูป
          source: "deductedItems", // บอก source ให้ชัด
          attachedImages: pickSnapshotsFor("deductedItems", it.createdAt),
        };
      });

      const dedItems = [...dedFromImpurities, ...dedFromState];

      // ====== แนบรูปให้ normalImpurities ทีละแถว ======
      const normalImpuritiesWithImages = normalImpurities.map((imp) => ({
        ...imp,
        attachedImages: pickSnapshotsFor("impurities", imp.createdAt),
      }));

      const productId = mainProduct?.id || selectedValue?.id;
      const productTitle = mainProduct?.title || selectedValue?.title;
      const categoryId = mainProduct?.categoryId ?? selectedValue?.categoryId;

      const normalImpuritiesWeight = normalImpurities.reduce(
        (s, it) => s + parseFloat(it.weight || 0),
        0
      );
      const dedItemsWeight = dedItems.reduce(
        (s, it) => s + parseFloat(it.weight || 0),
        0
      );
      const netFromSubmit =
        parseFloat(weight || 0) -
        parseFloat(deduct || 0) -
        (normalImpuritiesWeight + dedItemsWeight);

      onSubmit({
        ...selectedValue,
        id: productId,
        title: productTitle,
        categoryId,
        finalPrice: latestFinalPriceRef.current,
        weight,
        deduct,
        netWeight: netFromSubmit,
        impurities: normalImpuritiesWithImages,
        deductedItems: dedItems,
        snapshots,
        generalSnapshots,
        productPrice,
        note,
        isLockedPrice: isLockedPriceState,
      });

      handleClose();
    } catch (error) {
      console.error("เกิดข้อผิดพลาดในการส่งข้อมูล:", error);
    }
  };

  const handleKeypadSubmit = async (result) => {
    if (isEditingNote) return;
    try {
      const capturedImage = await captureImage();
      if (capturedImage) {
        const uploadResult = await uploadFile(capturedImage);
        const url = uploadResult?.file;
        if (url) {
          const context = getCurrentSnapshotContext();
          setSnapshots((prev) => [
            ...prev,
            { url, at: new Date().toISOString(), context },
          ]);
        }
      }
    } catch (err) {
      console.log("Error capturing/uploading image:", err);
    }

    const rawValue = parseFloat(String(result ?? "0")) || 0;
    const safeNum = Math.round((rawValue + Number.EPSILON) * 100) / 100;
    if (focused === "weight") {
      if (isWeighed) return;
      setWeight(safeNum);
      if (hasPermission(["edit_deduct_weight"])) {
        setFocused("deduct");
        setIsFirstKeypress(true);
      }
      setInputValue(deduct ?? 0);
      setCursorPos(String(deduct ?? 0).length);
    } else if (focused === "deduct") {
      if (isWeighed) return;
      setDeduct(safeNum);
      if (hasPermission(["edit_total_weight"])) {
        setFocused("weight");
        setIsFirstKeypress(true);
      }
      setInputValue(weight ?? 0);
      setCursorPos(String(weight ?? 0).length);
    } else if (focused === "price") {
      syncFinalPrice(safeNum);
      setIsLockedPriceState(true);
      setFocused("weight");
      setIsFirstKeypress(true);
      setInputValue(weight ?? 0);
      setCursorPos(String(weight ?? 0).length);
    } else if (
      focusedImpurityField === "weight" &&
      focusedImpurityIndex != null
    ) {
      if (isWeighed) return;
      const target = mergedItems?.[focusedImpurityIndex];
      if (!target) return;
      const source =
        target.source === "deducted" ? "deductedItems" : "impurities";
      const key = target.createdAt;
      if (source === "impurities") {
        setImpurities((prev) =>
          prev.map((x) =>
            x.createdAt === key ? { ...x, weight: safeNum } : x
          )
        );
      } else {
        setDeductedItems((prev) =>
          prev.map((x) =>
            x.createdAt === key
              ? { ...x, weight: safeNum, weight2: safeNum }
              : x
          )
        );
      }
      setInputValue(safeNum);
      setCursorPos(String(safeNum).length);
    }
  };

  const handleSelectPrice = (newPrice) => {
    syncFinalPrice(newPrice.finalPrice);
    setIsLockedPriceState(true);
    setOpenPriceDialog(false);
    setTimeout(() => focusMainWeight(), 0);
  };

  const cancelProductPick = () => {
    setOpenProdDialog(false);
    setSelectedId(null);
    if (prodPickerIndex !== null && prodPickerSource) {
      if (prodPickerSource === "impurities") {
        setImpurities((prev) => {
          const arr = [...prev];
          const row = arr[prodPickerIndex];
          if (row && row.type === "__deduct_product__" && !row.productId) {
            arr[prodPickerIndex] = {
              ...row,
              type: "",
              productId: undefined,
              productName: undefined,
            };
          }
          return arr;
        });
      }
      setProdPickerIndex(null);
      setProdPickerSource(null);
    }
  };

  const handleImpurityChange = (mergedIndex, field, value) => {
    const item = mergedItems[mergedIndex];
    if (!item) return;
    const source = item.source || "impurities"; // แหล่งข้อมูล: impurities หรือ deductedItems

    if (field === "kind") {
      // ถ้าแก้ kind (วิธีหัก)
      if (source === "impurities") {
        setImpurities((prev) =>
          prev.map((x) =>
            x.createdAt === item.createdAt ? { ...x, kind: value, type: "" } : x
          )
        );
      } else {
        setDeductedItems((prev) =>
          prev.map((x) =>
            x.createdAt === item.createdAt ? { ...x, kind: value } : x
          )
        );
      }

      setFocusedImpurityField("type");
      setFocusedImpuritySource(source);
      setTimeout(() => focusImpurityTypeAt(source, item.createdAt), 0);
      return;
    }

    if (field === "type") {
      // ถ้าแก้ type (เลือกสิ่งเจือปน)
      if (source === "impurities") {
        setImpurities((prev) =>
          prev.map((x) =>
            x.createdAt === item.createdAt
              ? {
                ...x,
                type: value,
                kind: x.kind?.trim() || inferKindFromType(value),
              }
              : x
          )
        );

        setTimeout(() => {
          focusImpurityWeightAt(source, mergedIndex); // ต้องแน่ใจว่าใช้ item.createdAt
        }, 0);
      } else if (source === "deducted") {
        setDeductedItems((prev) =>
          prev.map((x) =>
            x.createdAt === item.createdAt
              ? { ...x, type: value, kind: x.kind || inferKindFromType(value) }
              : x
          )
        );

        setTimeout(() => {
          focusImpurityWeightAt(source, mergedIndex); // ต้องแน่ใจว่าใช้ item.createdAt
        }, 0);
      }
    }
  };

  const addImpurity = () => {
    setImpurities((prev) => [
      ...prev,
      { kind: "", type: "", weight: 0, createdAt: new Date() },
    ]);
  };

  const removeImpurityAt = (mergedIndex) => {
    const item = mergedItems[mergedIndex];
    if (!item) return;

    if (item.source === "impurities") {
      setImpurities((prev) =>
        prev.filter((x) => x.createdAt !== item.createdAt)
      );
    } else if (item.source === "deducted") {
      setDeductedItems((prev) =>
        prev.filter((x) => x.createdAt !== item.createdAt)
      );
    }

    setFocusedImpurityIndex(null);
    setFocusedImpurityField(null);
    setFocusedImpuritySource(null);
  };

  const mergedItems = [
    ...impurities.map((item) => ({ source: "impurities", ...item })),
    ...deductedItems.map((item) => ({
      ...item,
      source: "deducted",
      kind: "convert",
      type: "__deduct_product__",
      weight: item.weight2,
      productId: item.productId,
      productName: item.productName,
      pricePerUnit: item.pricePerUnit,
      isDeductProduct: true,
    })),
  ].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  const resolvePriceFromProduct = (prod) => {
    if (!prod) return 0;
    const num = (v) => Number(v ?? 0) || 0;
    return (
      num(prod.finalPriceWithGroup) ||
      num(prod.finalPrice) ||
      num(prod.price) ||
      num(prod.basePrice) +
      num(prod.branchAdjustment) +
      num(prod.groupAdjustment)
    );
  };

  const getCurrentSnapshotContext = () => {
    // ค่า default
    const base = { type: "unknown" };

    // 1) ช่องหลัก: รวม/หัก/ราคา
    if (focused === "weight") return { type: "weight" };
    if (focused === "deduct") return { type: "deduct" };
    if (focused === "price") return { type: "price" };

    // 2) ช่องสิ่งเจือปน/หักเป็นสินค้าอื่น
    if (focusedImpurityField === "weight" && focusedImpurityIndex != null) {
      // item จาก mergedItems (รวมทั้ง impurities + deductedItems แล้วเรียงตาม createdAt)
      const target = mergedItems?.[focusedImpurityIndex];
      if (!target) return base;

      // normalize ที่มา (จะได้เหลือสองค่าแน่ ๆ)
      const normalizeSource = (s) =>
        s === "deducted" ? "deductedItems" : s || "impurities";
      const source = normalizeSource(target.source);

      const isDeductProduct =
        target.type === "__deduct_product__" || target.isDeductProduct;

      // บอกว่าเป็นแถวไหน (index), มาจากตารางไหน (source), และกุญแจอ้างอิง (createdAt)
      const ctx = {
        type: "impurity",
        field: "weight",
        source, // "impurities" | "deductedItems"
        index: focusedImpurityIndex, // index หลัง merge (ไว้บอกว่า "ช่องไหน")
        createdAt: target.createdAt, // คีย์อ้างอิงเสถียร
        isDeductProduct,
      };

      // ถ้าเป็น “หักเป็นสินค้าอื่น” แนบชื่อ/ไอดีสินค้าไปด้วย
      if (isDeductProduct) {
        ctx.productId = target.productId ?? null;
        ctx.productName = target.productName ?? null;
      }

      // เผื่ออยากโชว์ข้อความอ่านง่ายฝั่งเซิร์ฟเวอร์/UI
      ctx.label = isDeductProduct
        ? `สิ่งเจือปน(หักเป็นสินค้าอื่น) แถวที่ ${focusedImpurityIndex + 1}${ctx.productName ? ` - ${ctx.productName}` : ""}`
        : `สิ่งเจือปน แถวที่ ${focusedImpurityIndex + 1}${target.type ? ` - ${target.type}` : ""}`;

      return ctx;
    }

    return base;
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '16px',
            overflow: 'hidden',
            maxHeight: '95vh'
          }
        }}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-white sticky top-0 z-10">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-blue-50">
            </div>
            <div className="flex items-center gap-2">
              <h2 className="text-[30px] font-bold text-gray-800">
                {mainProduct?.title || selectedValue?.title}
              </h2>
              <button
                onClick={() => setOpenMainProdDialog(true)}
                className="p-1 hover:bg-gray-100 rounded-full transition-colors text-gray-400"
              >
                <EditIcon className="!text-xl" />
              </button>
            </div>
          </div>

          <div className="flex-1 flex justify-center items-center px-4">
            {hasPermission(["show_price_in_ticket"]) && (
              <div
                onClick={() => {
                  setFocused("price");
                  setInputValue(productPrice?.finalPrice ?? 0);
                  setIsFirstKeypress(true);
                  setIsEditingNote(false);
                  setFocusedImpurityIndex(null);
                  setFocusedImpurityField(null);
                  setFocusedImpuritySource(null);
                  if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
                }}
                className={`flex items-center gap-3 px-4 py-2 rounded-xl transition-all border cursor-pointer ${focused === 'price' ? 'border-blue-500 bg-blue-50/20' : 'border-transparent hover:bg-gray-50'}`}
              >
                <div className="text-sm font-bold text-gray-500">ราคาต่อหน่วย</div>
                <div className="flex items-center gap-2">
                  {(productPrice?.isFixed || isLockedPriceState) && <LockIcon className="text-blue-400 !text-sm" />}
                  <span className="text-3xl font-black text-blue-600 leading-none">
                    {formatNumber(productPrice?.finalPrice ?? 0)}
                  </span>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenPriceDialog(true);
                    }}
                    className="text-blue-500 hover:bg-blue-100 p-1 rounded-lg transition-colors"
                  >
                    <FormatListBulletedIcon fontSize="small" />
                  </button>
                </div>
              </div>
            )}
          </div>

          <button
            onClick={handleClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-500"
          >
            <CloseIcon />
          </button>
        </div>

        <DialogContent className="!p-6 bg-gray-50/30"
          sx={{
            overflowY: "auto",
            maxHeight: "calc(95vh - 160px)" // หัก header + footer
          }}>
          <div className="grid grid-cols-12 gap-6 items-stretch">

            {/* Left: Webcam */}
            <div className="col-span-12 lg:col-span-4 h-full flex flex-col gap-4">
              <div className="h-full min-h-[400px] lg:min-h-0 bg-black rounded-2xl overflow-hidden relative shadow-sm ring-1 ring-gray-200">
                <Webcam
                  ref={webcamRef}
                  key={selectedDeviceId}
                  audio={false}
                  screenshotFormat="image/jpeg"
                  screenshotQuality={0.9}
                  className="w-full h-full object-contain"
                  videoConstraints={{
                    width: 1920,
                    height: 1080,
                    deviceId: selectedDeviceId ? { exact: selectedDeviceId } : undefined,
                  }}
                />

                {/* Camera Selector Overlay */}
                <div className="absolute top-4 left-4 right-4 flex items-center gap-2 bg-white/90 backdrop-blur-sm rounded-lg p-1.5 border border-white/20 shadow-lg">
                  <div className="w-2.5 h-2.5 bg-green-500 rounded-full animate-pulse ml-1" />
                  <select
                    value={selectedDeviceId}
                    onChange={(e) => {
                      const val = e.target.value;
                      setSelectedDeviceId(val);
                      localStorage.setItem("preferred_camera_product_form", val);
                    }}
                    className="bg-transparent border-none text-xs font-semibold focus:ring-0 outline-none cursor-pointer flex-1"
                  >
                    {devices.map((d) => (
                      <option key={d.deviceId} value={d.deviceId}>
                        {d.label || `กล้อง ${d.deviceId}`}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="absolute bottom-4 left-4 flex items-center gap-2 bg-black/40 backdrop-blur-sm px-2 py-1 rounded-full text-[10px] font-bold text-white uppercase tracking-wider">
                  <div className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse" />
                  REC
                </div>
              </div>

              <textarea
                className="w-full text-sm p-3 rounded-xl border border-gray-100 bg-gray-50/50 focus:bg-white transition-all outline-none resize-none h-32"
                placeholder="หมายเหตุ..."
                value={note}
                onChange={(e) => setNote(e.target.value)}
                onFocus={() => {
                  setIsEditingNote(true);
                  setFocused(null);
                  setFocusedImpurityIndex(null);
                  setFocusedImpurityField(null);
                  setFocusedImpuritySource(null);
                }}
                onBlur={() => setIsEditingNote(false)}
              />
            </div>

            {/* Middle: Details & Weights */}
            <div className="col-span-12 lg:col-span-5 space-y-6">

              {/* Weight Card */}
              <div
                onClick={() => {
                  if (isWeighed) return;
                  setFocused("weight");
                  setInputValue(weight || 0);
                  setIsFirstKeypress(true);
                  setIsEditingNote(false);
                  setFocusedImpurityIndex(null);
                  setFocusedImpurityField(null);
                  setFocusedImpuritySource(null);
                  if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
                }}
                className={`p-4 rounded-2xl border-2 transition-all duration-200 bg-white ${isWeighed ? "opacity-60 cursor-not-allowed" : "cursor-pointer"} ${focused === 'weight' ? 'border-emerald-500 shadow-lg shadow-emerald-50' : 'border-emerald-500/30'}`}
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <ScaleIcon className="text-emerald-500" />
                    <span className="text-sm font-bold text-emerald-700">น้ำหนักชั่ง (รวม)</span>
                  </div>
                  <div className="bg-emerald-500 text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-tighter">Auto</div>
                </div>
                <div className="flex items-baseline justify-end gap-2">
                  <div className="text-right w-full text-5xl font-black text-slate-800 leading-none">
                    {formatNumber(weight)}
                  </div>
                  <span className="text-xl font-bold text-slate-400">กก.</span>
                </div>
              </div>


              <div
                onClick={() => {
                  if (isWeighed) return;
                  setFocused("deduct");
                  setInputValue(deduct || 0);
                  setIsFirstKeypress(true);
                  setIsEditingNote(false);
                  setFocusedImpurityIndex(null);
                  setFocusedImpurityField(null);
                  setFocusedImpuritySource(null);
                  if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
                }}
                className={`p-3 rounded-xl border transition-all ${isWeighed ? "opacity-60 cursor-not-allowed" : "cursor-pointer"} ${focused === 'deduct' ? 'border-red-500 bg-red-50/20' : 'border-gray-200 bg-white'}`}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <ScaleIcon className="text-emerald-500" />
                    <span className="text-sm font-bold text-emerald-700">น้ำหนักชั่ง (หัก)</span>
                  </div>
                </div>
                <div className="flex items-baseline justify-end gap-2">
                  <div className="text-right w-full text-5xl font-black text-red-500 leading-none">
                    {formatNumber(deduct)}
                  </div>
                  <span className="text-xl font-bold text-slate-400">กก.</span>
                </div>
              </div>


              {/* Impurities Section */}
              <div className="space-y-4">
                <button
                  onClick={addImpurity}
                  disabled={isWeighed}
                  className={`w-full py-4 border-2 border-dashed border-gray-100 rounded-[2rem] flex items-center justify-center gap-2 text-gray-500 font-bold text-lg transition-all ${isWeighed ? 'opacity-50 cursor-not-allowed' : 'hover:border-gray-200 hover:bg-gray-50'}`}
                >
                  <AddCircleOutlineIcon className="!text-2xl" />
                  เพิ่มสิ่งเจือปน
                </button>

                <div className="space-y-3 max-h-[220px] overflow-y-auto pr-1 customize-scrollbar">
                  {mergedItems.map((item, index) => {
                    const source = item.source;
                    const selectedProduct = (products || []).find((p) => p.createdAt === item.createdAt);
                    const isFocused = focusedImpurityIndex === index;

                    return (
                      <div key={`${source}-${index}`} className="border border-gray-100 rounded-[1.5rem] p-4 bg-white shadow-sm">
                        <div className="grid grid-cols-12 gap-3 items-stretch">
                          {/* Left: Deduct Method */}
                          <div className={`col-span-3 border rounded-2xl px-3 py-4 transition-all flex items-center ${isWeighed ? 'opacity-70 bg-gray-50' : ''} ${isFocused && focusedImpurityField === 'kind' ? 'border-blue-300' : 'border-gray-200'}`}>
                            <select
                              value={item.kind || ""}
                              onChange={(e) => handleImpurityChange(index, "kind", e.target.value)}
                              disabled={isWeighed}
                              className={`w-full bg-transparent border-none text-base font-black text-slate-700 focus:ring-0 outline-none p-0 ${isWeighed ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            >
                              <option value="">วิธีหัก</option>
                              {deductKindOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                              ))}
                            </select>
                          </div>

                          {/* Middle: Impurity Type */}
                          <div className={`col-span-5 border rounded-2xl px-3 py-4 transition-all flex items-center ${isWeighed ? 'opacity-70 bg-gray-50' : ''} ${isFocused && focusedImpurityField === 'type' ? 'border-blue-300' : 'border-gray-200'}`}>
                            <div className="relative w-full">
                              {item.kind === 'convert' ? (
                                <button
                                  onClick={() => {
                                    if (isWeighed) return;
                                    setProdPickerIndex(index);
                                    setProdPickerSource(source);
                                    setOpenProdDialog(true);
                                  }}
                                  disabled={isWeighed}
                                  className={`w-full text-left text-base font-black truncate text-blue-600 ${isWeighed ? 'cursor-not-allowed text-blue-400' : 'hover:underline'}`}
                                >
                                  {item.productName || "เลือกสินค้า..."}
                                </button>
                              ) : (
                                <select
                                  value={item.type || ""}
                                  onChange={(e) => handleImpurityChange(index, "type", e.target.value)}
                                  disabled={isWeighed}
                                  className={`w-full bg-transparent border-none text-base font-black text-slate-700 focus:ring-0 outline-none p-0 ${isWeighed ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                >
                                  <option value="">สิ่งเจือปน</option>
                                  {getTypeOptionsByKind(item.kind).map((type, i) => (
                                    <option key={i} value={type}>{type}</option>
                                  ))}
                                </select>
                              )}
                            </div>
                          </div>

                          {/* Right: Weight Input */}
                          <div className={`col-span-3 border rounded-2xl px-3 py-4 transition-all flex items-center ${isWeighed ? 'opacity-70 bg-gray-50' : ''} ${isFocused && focusedImpurityField === 'weight' ? 'border-blue-300 bg-blue-50/10' : 'border-gray-200'}`}>
                            <input
                              ref={(el) => (impurityWeightRefs.current[`${source}-${index}`] = el)}
                              readOnly
                              type="text"
                              value={item.weight}
                              className={`w-full text-center text-2xl font-black bg-transparent border-none focus:ring-0 p-0 ${isWeighed ? 'cursor-not-allowed text-slate-500' : isFocused ? 'text-blue-600' : 'text-slate-800'}`}
                              onFocus={() => {
                                if (isWeighed) return;
                                if (!item.kind) return;
                                setFocused(null);
                                setFocusedImpurityIndex(index);
                                setFocusedImpurityField("weight");
                                setFocusedImpuritySource(source);
                                setInputValue(item.weight?.toString() || 0);
                                setIsFirstKeypress(true);
                                setIsEditingNote(false);
                              }}
                            />
                          </div>

                          {/* Action: Delete */}
                          <div className="col-span-1 flex items-center justify-end">
                            <button
                              onClick={() => !isWeighed && removeImpurityAt(index)}
                              disabled={isWeighed}
                              className={`rounded-lg p-1.5 transition-all shadow-md ${isWeighed ? 'bg-gray-300 text-gray-500 cursor-not-allowed opacity-50' : 'bg-red-600 hover:bg-red-700 text-white active:scale-95'}`}
                            >
                              <CloseIcon className="!text-lg" />
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Summary Bottom - Sticky */}
              <div className="sticky bottom-0 bg-gray-50/95 backdrop-blur-sm pt-4 pb-2 border-t border-gray-200 space-y-2 z-10 -mx-2 px-4 shadow-sm">
                <div className="flex justify-between items-center">
                  <span className="text-lg font-bold text-gray-500 uppercase tracking-wider">น้ำหนักสุทธิ</span>
                  <div className="flex items-center gap-2">
                    <span className={`text-3xl font-black ${isNetNegative ? 'text-red-500' : 'text-slate-800'}`}>
                      {formatNumber(netWeight)}
                    </span>
                    <span className="text-lg font-bold text-gray-400">กก.</span>
                  </div>
                </div>
                {hasPermission(["show_price_in_ticket"]) && (
                  <div className="flex justify-between items-center">
                    <span className="text-lg font-bold text-gray-500 uppercase tracking-wider">รวมราคา</span>
                    <div className="flex items-center gap-2">
                      <span className="text-3xl font-black text-emerald-600">
                        {formatNumber(netWeight * (productPrice?.finalPrice || 0))}
                      </span>
                      <span className="text-2xl font-bold text-gray-400">฿</span>
                    </div>
                  </div>
                )}
              </div>



            </div>

            {/* Right: Keypad & Action */}
            <div className="col-span-12 lg:col-span-3 bg-white rounded-2xl p-4 shadow-sm border border-gray-100 flex flex-col">
              <div className="h-[520px]">
                <Keypad
                  value={inputValue}
                  cursorPos={cursorPos}
                  onChange={(val) => {
                    if (isEditingNote) return;
                    if (isWeighed && focused !== "price") return;
                    if (focused === "price") {
                      syncFinalPrice(val);
                    }
                    setInputValue(val);
                    setCursorPos(String(val ?? 0).length);
                  }}
                  onCursorChange={(pos) => {
                    setCursorPos(pos);
                  }}
                  onClear={() => {
                    if (isEditingNote) return;
                    if (isWeighed && focused !== "price") return;
                    setInputValue(0);
                    setCursorPos(1);
                    if (focused === "weight") setWeight(0);
                    if (focused === "deduct") setDeduct(0);
                    if (focused === "price") {
                      syncFinalPrice(0);
                    }
                    if (focusedImpurityIndex !== null) {
                      if (focusedImpuritySource === "impurities") {
                        setImpurities((prev) => {
                          const arr = [...prev];
                          if (arr[focusedImpurityIndex]) arr[focusedImpurityIndex].weight = 0;
                          return arr;
                        });
                      } else if (focusedImpuritySource === "deducted") {
                        const j = focusedImpurityIndex - impurities.length;
                        setDeductedItems((prev) => {
                          const arr = [...prev];
                          if (arr[j]) arr[j] = { ...arr[j], weight2: 0 };
                          return arr;
                        });
                      }
                    }
                  }}
                  onSubmit={handleKeypadSubmit}
                />
              </div>



            </div>

          </div>
        </DialogContent>

        <div className="px-6 py-4 border-t border-gray-100 bg-white sticky bottom-0 z-10 w-full">
          <button
            onClick={handleSubmit}
            disabled={!canSubmit}
            className="w-full py-4 bg-emerald-500 hover:bg-emerald-600 active:transform active:scale-[0.98] disabled:bg-gray-200 text-white rounded-2xl shadow-lg shadow-emerald-100 transition-all flex flex-col items-center justify-center gap-0.5"
          >
            <div className="flex items-center gap-2 font-black text-xl">
              <CheckIcon className="!text-2xl" />
              ยืนยัน
            </div>
          </button>
        </div>
      </Dialog>

      {/* TODO */}
      <ProductSelectDialog
        open={openProdDialog}
        onClose={cancelProductPick}
        onConfirm={(prod) => {
          if (!prod) return cancelProductPick();
          const mergedIndex = prodPickerIndex;
          if (mergedIndex == null) return cancelProductPick();

          // 1) ชี้เป้าหมายจาก mergedItems ตามจริง
          const target = mergedItems?.[mergedIndex];
          if (!target) return cancelProductPick();

          // บางที่เก็บเป็น "deducted" ให้ normalize เป็น "deductedItems"
          const normalizeSource = (s) =>
            s === "deducted" ? "deductedItems" : s;
          const source = normalizeSource(target.source || "impurities");
          const createdKey = target.createdAt;
          if (!createdKey) return cancelProductPick();

          // 2) ของที่จะทับค่า (คงน้ำหนักเดิม + default kind=convert)
          const applyOverride = (prev) => ({
            ...prev,
            kind: prev?.kind || "convert",
            type: "__deduct_product__",
            productId: prod.id,
            productName: prod.title ?? prod.name ?? "",
            weight: Number(prev?.weight ?? 0),
          });

          // 3) อัปเดตด้วย createdAt (ไม่ใช้ index อีกแล้ว)
          if (source === "impurities") {
            setImpurities((prev) =>
              prev.map((x) =>
                x.createdAt === createdKey ? applyOverride(x) : x
              )
            );
          } else if (source === "deductedItems") {
            setDeductedItems((prev) =>
              prev.map((x) =>
                x.createdAt === createdKey ? applyOverride(x) : x
              )
            );
          }

          // 4) โฟกัสช่องน้ำหนักของรายการนั้นด้วย createdAt
          setTimeout(() => {
            focusImpurityWeightAt(source, mergedIndex);
          }, 0);

          // 5) ปิด dialog + ล้าง state
          setOpenProdDialog(false);
          setProdPickerIndex(null);
          setProdPickerSource(null);
        }}
        products={products}
        categories={categories}
      />

      <ProductSelectDialog
        open={openMainProdDialog}
        onClose={() => setOpenMainProdDialog(false)}
        onConfirm={(prod) => {
          const basePrice = resolveBasePriceFromProduct(prod);
          setMainProduct({
            id: prod.id,
            title: prod.title,
            categoryId: prod.category?.id,
          });

          // ตั้งราคาฐานไว้ก่อน แล้วให้ effect ด้านบนคำนวณ step price อัตโนมัติถ้าไม่มี group
          latestFinalPriceRef.current = basePrice;
          setProductPrice((prev) => ({
            ...(prev || {}),
            id: prod.id,
            basePrice,
            finalPrice: basePrice,
          }));
          setIsLockedPriceState(false);

          setOpenMainProdDialog(false);
          setTimeout(() => focusMainWeight(), 0);
        }}
        products={products}
        categories={categories}
        initialSelectedId={mainProduct?.id || selectedValue?.id}
      />

      <PriceSelectionDialog
        open={openPriceDialog}
        onClose={() => setOpenPriceDialog(false)}
        onSelect={handleSelectPrice}
        categoryId={mainProduct?.categoryId || selectedValue?.categoryId}
        productId={productPrice?.id}
        products={products}
        transaction={transaction}
        pricingMode="buy"
        currentWeight={netWeight}
        currentPrice={productPrice?.finalPrice}
        productName={
          mainProduct?.title ||
          selectedValue?.title ||
          products.find((item) => Number(item?.id) === Number(productPrice?.id))
            ?.title ||
          ""
        }
      />
    </>
  );
};

export default SimpleDialog;
